import { Utils } from "@/plugins/utils";

export default {
	namespaced: true,
	state: {
	},
	getters: {
		
	},
	mutations: {
		
	},
	actions: {
		async saveMessage(store, whb){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Gravando mensagem", indeterminate: true }, {root: true})

			let payload = await this._vm.$axios.post("/Scheduler/Scheduler/SaveMessage", whb)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				if (payload){
					store.dispatch("parameters/openDialog", {
						titleText: "Sucesso",
						titleColor: "green",
						text: "Mensagem agendada para envio!"
					}, { root: true })
				}
				return payload
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		init(store){
			this._vm.$axios.get("/Scheduler/Scheduler/Init")
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
		},
	}
}